export default __webpack_public_path__ + "static/media/Hemkunskap1.e5e2d881.jpeg";